import styled from 'styled-components';
// core
import { ASUHeader } from '@asu/component-header-footer/dist/asuHeaderFooter.es.js';

import desktopLogo from '../../images/arizona-state-university-logo-vertical.png';
import mobileLogo from '../../images/arizona-state-university-logo.png';
import { authConstants } from '../../functions/Auth';

const HeaderSection = styled.div`
  header {
    position: sticky;

    // this align the "Create" button
    .content-container {
      font-size: 1rem;
      border: 0;
      margin: 0;
      height: fit-content;
      align-items: start;
      flex-direction: row;
    }

    a {
      cursor: pointer;
    }
  }
`;

const routerUrl = {
  HOME: '/',
  FIND_CLASSES: '/',
  MANAGE_USERS: '/users',
};

const Header = () => {
  const userString = localStorage.getItem('syllabus-app.user');
  const user = !!userString ? JSON.parse(userString) : null;
  const viewAs = sessionStorage.getItem('viewAs');
  const path = window.location.pathname.split('/');

  const handleClearViewAs = () => {
    sessionStorage.removeItem('viewAs');
    window.location.reload();
  };

  return (
    <HeaderSection>
      <ASUHeader
        title={path[1] !== 'syllabus' ? 'Syllabus Management' : 'Syllabus'}
        logo={{
          alt: 'logo',
          src: desktopLogo,
          mobileSrc: mobileLogo,
        }}
        loggedIn={
          localStorage.getItem(authConstants.SS_USER_NAME) &&
          localStorage.getItem(authConstants.SS_JWT_TOKEN)
        }
        userName={localStorage.getItem(authConstants.SS_USER_NAME)}
        logoutLink={authConstants.LOGOUT_URL}
        navTree={[
          //   {
          //     href: routerUrl.HOME,
          //     text: "Home",
          //     type: "icon-home",
          //     class: "home",
          //     selected: false,
          //   },
          ...(user?.isAdmin && !viewAs
            ? [
                {
                  href: routerUrl.FIND_CLASSES,
                  text: 'Find Classes',
                  selected:
                    window.location.pathname === routerUrl.FIND_CLASSES
                      ? true
                      : false,
                },
                {
                  href: routerUrl.MANAGE_USERS,
                  text: 'View Users',
                  selected:
                    window.location.pathname === routerUrl.MANAGE_USERS
                      ? true
                      : false,
                },
              ]
            : []),
          ...(viewAs
            ? [
                {
                  text: `Viewing as ${viewAs}`,
                },
              ]
            : []),
        ]}
        buttons={[
          ...(viewAs
            ? [
                {
                  text: 'Clear view as',
                  onClick: handleClearViewAs,
                  color: 'dark',
                },
              ]
            : []),
        ]}
        searchUrl="https://search.asu.edu/search"
      />
    </HeaderSection>
  );
};

export default Header;
